import Vue from 'vue'
import App from './App'
import router from './router'
import stores from './store/store'
import ElementUI from 'element-ui'
import {
  Session
} from '@/assets/js/storage'
import {
  getDicts
} from "@/assets/js/api";
// 导入常量类
import {
  Constants
} from '@/assets/js/constants';
import messageBox from "./utils/messageBox";
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
import './assets/css/ph2element.css'
// 字典数据组件
import DictData from '@/components/DictData'
// 字典标签组件
import DictTag from '@/components/DictTag'
// 阿里巴巴矢量图
import '@/assets/font/iconfont.js'
import '@/assets/font/iconfont.css'
import { parseTime, resetForm, handleTree, addBeginAndEndTime, divide} from "@/utils/ruoyi";
Vue.config.productionTip = false
Vue.component('DictTag', DictTag)
// 全局方法挂载
Vue.prototype.Session = Session
Vue.prototype.getDicts = getDicts
Vue.prototype.$constants = Constants;
Vue.prototype.parseTime = parseTime
Vue.use(ElementUI)
Vue.use(messageBox);
DictData.install()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: stores,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js